import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Injector } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ObjectTypes } from '@fi-shared/types';
import { IFormReportSubmission } from '../fi-form-report';
import { UserListProfileIconColumnComponent } from '@fi-app/user/user-list/user-list-profile-icon-column/user-list-profile-icon-column.component';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class FormReportActivityListData extends ListData<IFormReportSubmission> {
    constructor(injector: Injector, reportItemClickCallback: (item: IFormReportSubmission, parentData) => void) {
        super(injector, true);

        this.MultiSelect = false;
        this.ShowDelete = false;
        this.ShowCheckAll = false;
        this.ShowCheckBox = false;
        this.CanShowLoadMore = false;
        this.ObjectType = ObjectTypes.Form;
        this.ChildProperty = 'AnswerSets';

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder',
                    true,
                    UserListProfileIconColumnComponent,
                ),
                undefined,
                undefined,
                (data, propertyName, parentData) => (parentData ? parentData : data),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('colleague'),
                'FullName',
                new ItemsListHeaderProperties('CcmListItem-Name CcmListItem-NoBorder', true, ItemsListElementType.A, {
                    onClick: ($event, data: IFormReportSubmission, parentData) => {
                        $event.stopPropagation();
                        if (!parentData && data.AnswerSets.length !== 1) {
                            this.toggleChildrenItems(data);
                        } else {
                            reportItemClickCallback(data, parentData);
                        }
                    },
                }),
                undefined,
                undefined,
                (data, prop, parentData) => {
                    // NOTE: we need to remove ChildProperty if only one answer is present
                    // if (data.AnswerSets && data.AnswerSets.length === 1) {
                    //     this.ChildProperty = null;
                    // }
                    if (parentData) return parentData.FullName;
                    if (data.AnswerSets.length > 1) return `${data.FullName} (${data.AnswerSets.length})`;
                    return data.FullName;
                },
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.area'),
                'LatestAreaName',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    {
                        isRightAligned: true,
                        useParentDataForDisplay: true,
                    },
                ),
                undefined,
                undefined,
                (data, prop, parentData) => {
                    if (parentData) return data.AreaName;
                    return data.LatestAreaName;
                },
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.unit'),
                'LatestBusinessUnitName',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    {
                        isRightAligned: true,
                        useParentDataForDisplay: true,
                    },
                ),
                undefined,
                undefined,
                (data, prop, parentData) => {
                    if (parentData) return data.BusinessUnitName;
                    return data.LatestBusinessUnitName;
                },
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('form.submissions_date'),
                'LatestCreatedOn',
                new ItemsListHeaderProperties(
                    'CcmList-Column-Narrow CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
                null,
                null,
                (data, prop, parentData) => {
                    if (parentData) {
                        return injector.get(FiFormatDateService).formatDate(data.CreatedOn, 'date');
                    }
                    return injector.get(FiFormatDateService).formatDate(data.LatestCreatedOn, 'date');
                },
            ),
        );
    }

    getRowClass(data: IFormReportSubmission) {
        if (data && data.AnswerSets && data.AnswerSets.length === 1) return 'hide-collapse-icon';
    }
}
